export const TRANSACTIONS_PER_PAGE = 7;
export const CARDS_PER_PAGE = 36;
// export const GAMES_PER_PAGE = 30;
export const DECKS_PER_PAGE = 32;
// export const OFFERS_PER_PAGE = 7;
// export const ORDER_PER_PAGE = 30;
export const FRIENDS_PER_PAGE = 30;
export const REQUEST_PER_PAGE = 30;
export const EVENTS_PER_PAGE = 30;
export const EVENT_USERS_PER_PAGE = 30;
